import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dayjs } from "dayjs";
import { IAddress } from "./memberInterfaceStruct";

interface IState {
  [key: string]: any;
}

export interface IOtherStateBars {
  BarName: string;
  AdmitDate: Date;
  BarId: string;
}

export interface IMember {
  Personal: {
    BarId: string;
    MemberTypeId: number;
    MemberCodeId: number;
    Title: number;
    FirstName: string;
    LastName: string;
    Esquire: string;
    Gender: string;
    DateOfBirth: string;
    AdmitDate: string;
    IsValidSupremeCourtId: boolean;
    IsMediator: boolean;
    MediatorCertificationEndsOn: string;
  };
  PrimaryAddress: {
    Id: number;
    FirmName: string;
    Address1: string;
    Address2: string;
    City: string;
    County: string;
    State: string;
    Zipcode: string;
    PhoneNumber: string;
    CellPhoneNumber: string;
    FaxNumber: string;
    Email: string;
  };
  PublishedAddress: {
    Id: number;
    FirmName: string;
    Address1: string;
    Address2: string;
    City: string;
    County: string;
    State: string;
    Zipcode: string;
    PhoneNumber: string;
    CellPhoneNumber: string;
    FaxNumber: string;
    Email: string;
    FirmAdminName: string;
    FirmAdminEmailId: string;
    FirmAdminPhoneNumber: string;
  };
  Sections: number[];
  enrollmentStartDate: string;
  enrollmentEndDate: string;
  Tags: number[];
  OtherStateBars: IOtherStateBars[];
  Comments: string;
  CurrentPage: number;
  Paginate: number;
  SortBy: string;
  SortType: string;
}
// interface dummyKeyPair {
// 	[key: string]: any
// }

// export interface IMembership {
//   EventType: string | null;
//   Id: number | null;
//   SectionName: string | null;
//   Fee: number | null;
// }

// export interface ISection {
//   Fee: number;
//   Id: number;
//   SectionDescription: string;
//   SectionName: string;
//   isSelected: boolean;
// }

// export interface IOrderItem {
//   // Id: number | null;
//   OrderItemId: number | null;
//   MemberCodeId: number | null;
//   OrderType: string | null;
//   MemberCode: string | null;
//   MemberCodeFee: number | null;
//   MemberCodeDesc: string | null;
//   CurrentOrderSections: number[] | [];
//   membershipItemList: IMembership[] | [];
// }

// export interface IOrder {
//   MemberId: number | null;
//   OrderAmount: number;
//   TransactionType: string | null; // this is Transaction Type
//   OrderDate: string | null;
//   NoInvoice: boolean | null;
//   Orders: IOrderItem[] | [];
//   HasMembershipOrderItem: boolean;
//   HasSectionOrderItem: boolean;
//   Sections: ISection[];
// }

// const initialOrderItem: IOrderItem = {
//   // Id: number | null;
//   OrderItemId: null,
//   MemberCodeId: null,
//   OrderType: null,
//   MemberCode: null,
//   MemberCodeFee: null,
//   MemberCodeDesc: null,
//   CurrentOrderSections: [],
//   membershipItemList: [],
// };

// const initialCurrentOrder: IOrder = {
//   MemberId: null,
//   OrderAmount: 0,
//   TransactionType: null, // this is Transaction Type
//   OrderDate: null,
//   NoInvoice: false,
//   Orders: [],
//   HasMembershipOrderItem: false,
//   HasSectionOrderItem: false,
//   Sections: [],
// };

const initialState: IState = {
  Personal: {
    BarId: null,
    MemberTypeId: 1,
    MemberCodeId: null,
    Title: null,
    FirstName: null,
    LastName: null,
    Esquire: null,
    Gender: null,
    DateOfBirth: null,
    AdmitDate: null,
    IsValidSupremeCourtId: null,
    IsMediator: null,
    MediatorCertificationEndsOn: null,
  },
  PrimaryAddress: {
    Id: null,
    FirmName: null,
    Address1: null,
    Address2: null,
    City: null,
    County: null,
    State: null,
    Zipcode: null,
    PhoneNumber: null,
    CellPhoneNumber: null,
    FaxNumber: null,
    Email: null,
  },
  PublishedAddress: {
    Id: null,
    FirmName: null,
    Address1: null,
    Address2: null,
    City: null,
    County: null,
    State: null,
    Zipcode: null,
    PhoneNumber: null,
    CellPhoneNumber: null,
    FaxNumber: null,
    Email: null,
    FirmAdminName: null,
    FirmAdminEmailId: null,
    FirmAdminPhoneNumber: null,
  },
  Sections: [],
  enrollmentStartDate: null,
  enrollmentEndDate: null,
  Tags: [],
  OtherStateBars: null,
  Comments: null,
  // currentOrder: initialCurrentOrder,
  FindMemberData: {
    MemberId: null,
  },
  CurrentPage: 1,
  Paginate: 25,
  SortBy: "LastName",
  SortType: "ASC",
};

type BodyType = {
  key: string;
  value: string | Number | boolean | number[] | string[] | null;
};

export const memberApiSlice = createSlice({
  name: "apiSlice",
  initialState,
  reducers: {
    updateCreatememberBody: (state: any, action: PayloadAction<IState>) => {
      // state.payload.dummyKeyPair.key = action.payload.dummyKeyPair.value;
      //  state.createMemberBody = {...state.createMemberBody, action.payload};
      // state.createMemberBody = {...state.createMemberBody + action.payload};
      console.log("ap..", action.payload);
      const { key, value } = action.payload;
      // if (!state.createMemberBody[key]) {
      // 	state.createMemberBody[key] = []
      //   }
      state.createMemberBody[key] = value;
      //what do do here
    },

    updateMemberPersonalInfo: (state: any, action: PayloadAction<BodyType>) => {
      console.log(
        "PersonalBody:",
        action.payload.key,
        ":",
        action.payload.value
      );
      state.Personal[action.payload.key] = action.payload.value;
    },

    // updateMember_BarId: (state: any, action: PayloadAction<string>) => {
    //   state.Personal.BarId = action.payload;
    // },
    // updateMember_MemberTypeId: (state: any, action: PayloadAction<number>) => {
    //   state.Personal.MemberTypeId = action.payload;
    // },

    // updateMember_MemberCodeId: (state: any, action: PayloadAction<number>) => {
    //   state.Personal.MemberCodeId = action.payload;
    // },

    // updateMember_FirstName: (state: any, action: PayloadAction<string>) => {
    //   state.Personal.FirstName = action.payload;
    // },
    // updateMember_LastName: (state: any, action: PayloadAction<string>) => {
    //   state.Personal.LastName = action.payload;
    // },
    // updateMember_DateOfBirth: (state: any, action: PayloadAction<string>) => {
    //   state.Personal.DateOfBirth = action.payload;
    // },
    // updateMember_AdmitDate: (state: any, action: PayloadAction<string>) => {
    //   state.Personal.AdmitDate = action.payload;
    // },
    // updateMember_Title: (state: any, action: PayloadAction<string>) => {
    //   state.Personal.Title = action.payload;
    // },
    // updateMember_Esquire: (state: any, action: PayloadAction<string>) => {
    //   state.Personal.Esquire = action.payload;
    // },
    // updateMember_Gender: (state: any, action: PayloadAction<string>) => {
    //   state.Personal.Gender = action.payload;
    // },
    // updateMember_IsMediator: (state: any, action: PayloadAction<boolean>) => {
    //   state.Personal.IsMediator = action.payload;
    // },
    // updateMember_MediatorCertificationEndsOn: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.Personal.MediatorCertificationEndsOn = action.payload;
    // },

    //PrimaryAddress///

    updateMemberPrimaryAddressInfo: (
      state: any,
      action: PayloadAction<BodyType>
    ) => {
      console.log(
        "PrimaryAddress:",
        action.payload.key,
        ":",
        action.payload.value
      );
      state.PrimaryAddress[action.payload.key] = action.payload.value;
    },

    // updateMember_PrimaryAddressFirmName: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PrimaryAddress.FirmName = action.payload;
    // },
    // updateMember_PrimaryAddressAddress1: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PrimaryAddress.Address1 = action.payload;
    // },
    // updateMember_PrimaryAddressAddress2: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PrimaryAddress.Address2 = action.payload;
    // },
    // updateMember_PrimaryAddressCity: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PrimaryAddress.City = action.payload;
    // },
    // updateMember_PrimaryAddressCounty: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PrimaryAddress.County = action.payload;
    // },
    // updateMember_PrimaryAddressState: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PrimaryAddress.State = action.payload;
    // },
    // updateMember_PrimaryAddressZipCode: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PrimaryAddress.Zipcode = action.payload;
    // },
    // updateMember_PrimaryAddressPhoneNumber: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PrimaryAddress.PhoneNumber = action.payload;
    // },
    // updateMember_PrimaryAddressCellPhoneNumber: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PrimaryAddress.CellPhoneNumber = action.payload;
    // },
    // updateMember_PrimaryAddressFaxNumber: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PrimaryAddress.FaxNumber = action.payload;
    // },
    // updateMember_PrimaryAddressEmail: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PrimaryAddress.Email = action.payload;
    // },
    // updateMember_PrimaryAddressFirmAdminName: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PrimaryAddress.FirmAdminName = action.payload;
    // },

    //publish///

    updateMemberPublishAddress: (
      state: any,
      action: PayloadAction<IAddress>
    ) => {
      console.log("PublishAddress:", action.payload);
      state.PublishedAddress = action.payload;
    },

    updateMemberPublishAddressInfo: (
      state: any,
      action: PayloadAction<BodyType>
    ) => {
      console.log(
        "PublishAddress:",
        action.payload.key,
        ":",
        action.payload.value
      );
      state.PublishedAddress[action.payload.key] = action.payload.value;
    },

    // updateMember_PublishAddressFirmName: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.FirmName = action.payload;
    // },
    // updateMember_PublishAddressAddress1: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.Address1 = action.payload;
    // },
    // updateMember_PublishAddressAddress2: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.Address2 = action.payload;
    // },
    // updateMember_PublishAddressCity: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.City = action.payload;
    // },
    // updateMember_PublishAddressCounty: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.County = action.payload;
    // },
    // updateMember_PublishAddressState: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.State = action.payload;
    // },
    // updateMember_PublishAddressZipCode: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.Zipcode = action.payload;
    // },
    // updateMember_PublishAddressPhoneNumber: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.PhoneNumber = action.payload;
    // },
    // updateMember_PublishAddressCellPhoneNumber: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.CellPhoneNumber = action.payload;
    // },
    // updateMember_PublishAddressFaxNumber: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.FaxNumber = action.payload;
    // },
    // updateMember_PublishAddressEmail: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.Email = action.payload;
    // },
    // updateMember_PublishAddressFirmAdminName: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.FirmAdminName = action.payload;
    // },
    // updateMember_PublishAddressAdminPhoneNumber: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.FirmAdminPhoneNumber = action.payload;
    // },
    // updateMember_PublishAddressAdminEmailId: (
    //   state: any,
    //   action: PayloadAction<string>
    // ) => {
    //   state.PublishedAddress.FirmAdminEmail = action.payload;
    // },

    updateMember_Sections: (state: any, action: PayloadAction<number[]>) => {
      state.Sections = action.payload;
    },
    updateMember_Tags: (state: any, action: PayloadAction<number[]>) => {
      state.Tags = action.payload;
    },

    updateMember_OtherStateBar: (state: any, action: PayloadAction<any[]>) => {
      state.OtherStateBars = action.payload;
    },

    updateMember_Comments: (state: any, action: PayloadAction<string>) => {
      state.Comments = action.payload;
    },

    updateFM_MemberId: (state: any, action: PayloadAction<number>) => {
      state.FindMemberData.MemberId = action.payload;
    },
    setMemberCurrentPage: (state: any, action: PayloadAction<number>) => {
      state.CurrentPage = action.payload;
    },
    setMemberPaginate: (state: any, action: PayloadAction<number>) => {
      state.Paginate = action.payload;
    },
    setUpdateSortType: (state: any, action: PayloadAction<string>) => {
      state.SortType = action.payload;
    },
    setUpdateSortBy: (state: any, action: PayloadAction<string>) => {
      state.SortBy = action.payload;
    },
    setUpdateEnrollmentStartDate: (
      state: any,
      action: PayloadAction<string>
    ) => {
      state.enrollmentStartDate = action.payload;
      console.log("setUpdateEnrollmentStartDate", action.payload);
    },
    setUpdateEnrollmentEndDate: (state: any, action: PayloadAction<string>) => {
      state.enrollmentEndDate = action.payload;
      console.log("setUpdateEnrollmentEndDate", action.payload);
    },
    resetCreateBody: () => initialState,
  },
});

// Action creators are generated for each case reducer function
export const {
  updateCreatememberBody,
  updateMemberPersonalInfo,
  updateMemberPrimaryAddressInfo,
  updateMemberPublishAddressInfo,
  updateMemberPublishAddress,
  // updateMember_BarId,
  // updateMember_FirstName,
  // updateMember_LastName,
  // updateMember_DateOfBirth,
  // updateMember_MemberTypeId,
  // updateMember_MemberCodeId,
  // updateMember_AdmitDate,
  // updateMember_Title,
  // updateMember_Esquire,
  // updateMember_Gender,
  // updateMember_IsMediator,
  // updateMember_MediatorCertificationEndsOn,
  // updateMember_PrimaryAddressFirmName,
  // updateMember_PrimaryAddressAddress1,
  // updateMember_PrimaryAddressAddress2,
  // updateMember_PrimaryAddressCity,
  // updateMember_PrimaryAddressCounty,
  // updateMember_PrimaryAddressState,
  // updateMember_PrimaryAddressZipCode,
  // updateMember_PrimaryAddressPhoneNumber,
  // updateMember_PrimaryAddressCellPhoneNumber,
  // updateMember_PrimaryAddressFaxNumber,
  // updateMember_PrimaryAddressEmail,
  // updateMember_PublishAddressFirmName,
  // updateMember_PublishAddressAddress1,
  // updateMember_PublishAddressAddress2,
  // updateMember_PublishAddressCity,
  // updateMember_PublishAddressCounty,
  // updateMember_PublishAddressState,
  // updateMember_PublishAddressZipCode,
  // updateMember_PublishAddressPhoneNumber,
  // updateMember_PublishAddressCellPhoneNumber,
  // updateMember_PublishAddressFaxNumber,
  // updateMember_PublishAddressAdminEmailId,
  // updateMember_PublishAddressAdminPhoneNumber,
  // updateMember_PublishAddressFirmAdminName,
  // updateMember_PublishAddressEmail,
  updateMember_Sections,
  updateMember_Tags,
  updateMember_OtherStateBar,
  updateMember_Comments,
  updateFM_MemberId,
  setMemberCurrentPage,
  setMemberPaginate,
  setUpdateSortType,
  setUpdateSortBy,
  setUpdateEnrollmentStartDate,
  setUpdateEnrollmentEndDate,
  resetCreateBody,
} = memberApiSlice.actions;

export default memberApiSlice.reducer;
